import guestEn from "./guest.en";

const guestFr: Record<string, string> = {
  ...guestEn,
  "guest.header.venueFallback": "Lieu",
  "guest.header.help": "Aide",
  "guest.language.label": "Langue",
  "guest.legal.terms": "Conditions d'utilisation",
  "guest.legal.privacy": "Politique de confidentialité",
  "guest.help.title": "Aide",
  "guest.help.body": "Nous avons averti votre serveur. Si vous avez encore besoin d’aide, fermez ce message et informez-le.",
  "guest.tabs.payment": "Paiement",
  "guest.tabs.newPurchases": "Nouveaux",
  "guest.selection.title": "Quoi payer",
  "guest.selection.subtitle": "Choisissez les additions",
  "guest.selection.selectAll": "Tout",
  "guest.selection.clear": "Effacer",
  "guest.selection.emptyOrders": "Vos additions apparaîtront ici",
  "guest.selection.notPayable": "Aucune addition payable",
  "guest.intent.title": "Que voulez-vous faire ?",
  "guest.intent.subtitle": "Choisissez l’action suivante pour cette table",
  "guest.intent.addPositions": "Ajouter des articles",
  "guest.intent.payAllPositions": "Payer toute la table",
  "guest.intent.payMyPositions": "Payer mes articles",
  "guest.intent.itemsUnavailableReason": "La composition de cette commande ouverte est temporairement indisponible. Demandez au serveur de rafraîchir la table avant le paiement par article.",
  "guest.intent.callWaiter": "Appeler le serveur",
  "guest.intent.leaveTip": "Laisser un pourboire",
  "guest.preorders.refresh": "Rafraîchir",
  "guest.preorders.course": "Ordre de service {course}",
  "guest.unified.queue.title": "Panier",
  "guest.stepper.select": "Choix",
  "guest.stepper.amount": "Montant",
  "guest.stepper.tip": "Pourboire",
  "guest.stepper.pay": "Payer",
  "guest.stepper.done": "Fini",
  "guest.common.back": "Retour",
  "guest.common.or": "ou",
  "guest.status.open": "Ouvert",
  "guest.status.closed": "Fermé",
  "guest.order.openedAt": "Ouvert {time}",
  "guest.order.paid": "Payé",
  "guest.order.remaining": "Reste",
  "guest.order.itemsLabel": "art.",
  "guest.order.hideFullList": "Masquer",
  "guest.order.moreItems": "+{count} plus",
  "guest.order.notPayable": "Non payable",
  "guest.order.leaveTip": "Laisser un pourboire",
  "guest.postVisitTip.notice": "Vous laissez un pourboire après visite pour l'addition {orderLabel}.",
  "guest.postVisitTip.min": "Le pourboire minimum par carte est de 1.00 {currency}.",
  "guest.footer.orderedTotal": "Commandé",
  "guest.footer.inCart": "Panier",
  "guest.footer.cartTotal": "Total panier",
  "guest.footer.selected": "Choisi",
  "guest.footer.payingNow": "À payer",
  "guest.footer.payer": "Payeur",
  "guest.footer.remainingAfter": "Reste après",
  "guest.footer.tip": "Pourboire",
  "guest.footer.total": "Total",
  "guest.payment.cta.continue": "Continuer",
  "guest.payment.cta.chooseAmount": "Choisir le montant",
  "guest.payment.cta.continueToTip": "Au tip",
  "guest.payment.cta.continueToPay": "Au paiement",
  "guest.payment.cta.emptyCartAndPay": "Payer",
  "guest.feedback.header": "Comment nous avez-vous trouvés ?",
  "guest.feedback.body.lovedIt": "Vous avez aimé ? Notez-nous.",
  "guest.feedback.body.improve": "À améliorer ? Dites-le en privé.",
  "guest.feedback.cta.publicReview": "J’ai adoré ⭐⭐⭐⭐⭐",
  "guest.feedback.cta.privateFeedback": "Dites-le-nous en privé",
  "guest.feedback.socialProof": "{count}+ clients nous ont notés 5★",
  "guest.feedback.source.question": "Comment nous avez-vous trouvés ?",
  "guest.feedback.source.google": "Google",
  "guest.feedback.source.instagram": "Instagram",
  "guest.feedback.source.tiktok": "TikTok",
  "guest.feedback.source.tripadvisor": "TripAdvisor",
  "guest.feedback.source.friends": "Amis",
  "guest.feedback.source.returning": "Déjà venu",
  "guest.feedback.source.press": "Presse",
  "guest.feedback.source.walkedBy": "En passant",
  "guest.feedback.destination.choose": "Où laisser un avis ?",
  "guest.feedback.secondary.title": "Autres plateformes pour nous évaluer",
  "guest.feedback.private.helper": "Ouvre votre application e-mail avec un message prérempli.",
  "guest.feedback.destination.email": "E-mail",
  "guest.feedback.destination.review": "Avis",
  "guest.feedback.visitType.label": "Êtes-vous déjà venu(e) ?",
  "guest.feedback.visitType.firstTime": "Première visite",
  "guest.feedback.visitType.returning": "Déjà venu(e)",
  "guest.payment.cta.done": "Passer",
  "guest.payment.cta.another": "Ajouter un paiement",
  "guest.order.whose": "À qui est la commande ?",
  "guest.order.guestName": "Client : {name}",
  "guest.order.newOrder": "Nouvelle commande",
  "guest.order.nameModal.title": "À qui est la commande ?",
  "guest.order.nameModal.placeholder": "Optionnel",
  "guest.common.cancel": "Annuler",
  "guest.common.clear": "Effacer",
  "guest.common.save": "Enregistrer",
  "guest.common.close": "Fermer",
  "guest.common.options": "Options",
  "guest.cart.inclOptions": "(options incluses)",
  "guest.scheduledVisit.success.title": "Précommande payée",
  "guest.scheduledVisit.success.body": "Paiement terminé. Cette précommande est en cours de traitement.",
  "guest.scheduledVisit.success.addItems": "Ajouter d'autres plats",
  "guest.scheduledVisit.success.back": "Retour à la table",
  "guest.scheduledVisit.success.reservationNumber": "Réservation n°",
  "guest.scheduledVisit.success.date": "Date",
  "guest.scheduledVisit.success.time": "Heure",
  "guest.scheduledVisit.success.place": "Table",
  "guest.scheduledVisit.success.waitlist": "Liste d'attente (table non attribuée)",
  "guest.scheduledVisit.success.guestName": "Nom du client",
  "guest.scheduledVisit.success.preorderItems": "Articles précommandés",
  "guest.scheduledVisit.success.course": "Ordre de service {course}",
  "guest.scheduledVisit.success.subtotal": "Sous-total",
  "guest.scheduledVisit.success.paid": "Payé",
  "guest.scheduledVisit.success.remaining": "Reste",
  "guest.scheduledUnified.common.loading": "Chargement de la visite planifiée…",
  "guest.scheduledUnified.common.back": "Retour",
  "guest.scheduledUnified.common.continue": "Continuer",
  "guest.scheduledUnified.visit.title": "Visite planifiée",
  "guest.scheduledUnified.visit.dateLabel": "Date",
  "guest.scheduledUnified.visit.guestsLabel": "Convives",
  "guest.scheduledUnified.visit.durationLabel": "Durée (min)",
  "guest.scheduledUnified.visit.availableTimeLabel": "Heures disponibles",
  "guest.scheduledUnified.visit.noSlots": "Aucun créneau pour la date sélectionnée.",
  "guest.scheduledUnified.visit.noTableAssigned": "La table n'est pas encore assignée. Le serveur l'assignera avant l'accès à la précommande.",
  "guest.scheduledUnified.cart.title": "Panier",
  "guest.scheduledUnified.cart.stepHint": "L'étape panier est prête. Vous ajouterez des articles juste après la confirmation de réservation.",
  "guest.scheduledUnified.cart.existingCount": "Paniers locaux existants : {count}",
  "guest.scheduledUnified.cart.empty": "Aucun article pour l'instant.",
  "guest.scheduledUnified.cart.preorderTitle": "Panier de précommande",
  "guest.scheduledUnified.cart.summary": "{count} articles • {total}",
  "guest.scheduledUnified.cart.chooseProduct": "Choisir un produit",
  "guest.scheduledUnified.cart.course": "Ordre de service {value}",
  "guest.scheduledUnified.cart.remove": "Supprimer",
  "guest.scheduledUnified.cart.edit": "Modifier",
  "guest.scheduledUnified.cart.menuTitle": "Menu",
  "guest.scheduledUnified.cart.menuSubtitle": "Choisissez des articles pour la précommande",
  "guest.scheduledUnified.cart.menuSearchPlaceholder": "Rechercher des plats",
  "guest.scheduledUnified.cart.menuEmpty": "Aucun résultat",
  "guest.scheduledUnified.cart.menuInCart": "Dans le panier : {count}",
  "guest.scheduledUnified.cart.addItem": "Ajouter un article",
  "guest.scheduledUnified.cart.itemFallback": "Article",
  "guest.scheduledUnified.cart.dialogDescription": "Configurez l'article avant de l'ajouter au panier.",
  "guest.scheduledUnified.cart.quantityLabel": "Quantité",
  "guest.scheduledUnified.cart.courseLabel": "Ordre de service",
  "guest.scheduledUnified.cart.commentLabel": "Commentaire",
  "guest.scheduledUnified.cart.commentPlaceholder": "Commentaire pour la cuisine / le serveur",
  "guest.scheduledUnified.cart.cancel": "Annuler",
  "guest.scheduledUnified.cart.updateItem": "Mettre à jour l'article",
  "guest.scheduledUnified.cart.addToCart": "Ajouter au panier",
  "guest.scheduledUnified.review.title": "Vérification",
  "guest.scheduledUnified.review.cta.bookAndPay": "Réserver et payer",
  "guest.scheduledUnified.review.date": "Date : {value}",
  "guest.scheduledUnified.review.time": "Heure : {value}",
  "guest.scheduledUnified.review.guests": "Convives : {value}",
  "guest.scheduledUnified.review.duration": "Durée : {value} min",
  "guest.scheduledUnified.review.guestNameLabel": "Nom",
  "guest.scheduledUnified.review.guestNamePlaceholder": "Votre nom",
  "guest.scheduledUnified.review.guestEmailLabel": "Email",
  "guest.scheduledUnified.review.guestEmailPlaceholder": "you@example.com",
  "guest.scheduledUnified.review.guestPhoneLabel": "Téléphone",
  "guest.scheduledUnified.review.guestPhonePlaceholder": "+33...",
  "guest.scheduledUnified.review.termsPrefix": "J'accepte",
  "guest.scheduledUnified.review.termsLink": "les conditions d'utilisation",
  "guest.scheduledUnified.review.privacyLink": "la politique de confidentialité",
  "guest.scheduledUnified.review.publicOfferLink": "l'offre publique",
  "guest.scheduledUnified.review.andWord": "et",
  "guest.scheduledUnified.review.personalDataPrefix": "Je consens au",
  "guest.scheduledUnified.review.personalDataLink": "traitement des données personnelles",
  "guest.scheduledUnified.waitlist.prompt": "Aucune table disponible. Rejoindre la liste d'attente ?",
  "guest.scheduledUnified.waitlist.join": "Rejoindre la liste d'attente",
  "guest.scheduledUnified.waitlist.changeTime": "Changer l'heure",
  "guest.scheduledUnified.waitlist.created": "Demande de liste d'attente créée.",
  "guest.scheduledUnified.featured.title": "Recommandés",
  "guest.scheduledUnified.featured.priceOnRequest": "Prix sur demande",
  "guest.scheduledUnified.result.successTitle": "Réservation et précommande confirmées",
  "guest.scheduledUnified.result.failureTitle": "Le paiement n'a pas été finalisé",
  "guest.scheduledUnified.result.failureBody": "La réservation n'a pas été finalisée. Veuillez réessayer.",
  "guest.scheduledUnified.failure.code": "Code d'échec : {value}",
  "guest.scheduledUnified.failure.noChargeHint": "Si votre banque a affiché une retenue, elle sera libérée automatiquement selon sa politique.",
  "guest.scheduledUnified.failure.changeTime": "Choisir un autre horaire",
  "guest.scheduledUnified.failure.retry": "Réessayer",
  "guest.scheduledUnified.steps.visit": "Visite",
  "guest.scheduledUnified.steps.cart": "Panier",
  "guest.scheduledUnified.steps.review": "Vérification",
  "guest.scheduledUnified.errors.merchantMissing": "Le paramètre merchant est absent dans l'URL du widget.",
  "guest.scheduledUnified.errors.invalidGuestName": "Le nom est requis.",
  "guest.scheduledUnified.errors.invalidGuestEmail": "Saisissez un email valide.",
  "guest.scheduledUnified.errors.invalidGuestPhone": "Saisissez un numéro de téléphone valide.",
  "guest.scheduledUnified.errors.selectTimeRequired": "Sélectionnez d'abord l'heure de la visite.",
  "guest.scheduledUnified.errors.selectDishRequired": "Remplissez votre panier avec tout le nécessaire pour que nous puissions tout préparer à l'heure de votre visite.",
  "guest.scheduledUnified.errors.termsNotAccepted": "Acceptez les conditions, la politique de confidentialité et l'offre publique pour continuer.",
  "guest.scheduledUnified.errors.personalDataConsentRequired": "Le consentement au traitement des données personnelles est requis.",
  "guest.errors.productStopped": "Certains articles ne sont plus disponibles. Actualisez le menu et retirez les articles indisponibles de votre panier.",
  "guest.loyalty.collapsible.prompt": "Vous avez une carte de fidélité ?",
  "guest.loyalty.collapsible.selected": "Fidélité : {mask}",
};

export default guestFr;
